import { GeoJSON } from 'react-leaflet';
import L from 'leaflet';

export default function TERRRAPointsLayer({ geojson }) {
  if (!geojson) return null;
  return (
    <GeoJSON
      key={JSON.stringify(geojson).slice(0, 40)}
      data={geojson}
      pointToLayer={(feature, latlng) => L.circleMarker(latlng, {
        radius: 8, fillColor: '#ff6b35', color: '#fff', weight: 2,
        opacity: 1, fillOpacity: 0.9,
      })}
      onEachFeature={(feature, layer) => {
        const p = feature.properties || {};
        layer.bindPopup(`
          <strong>${p.label || 'SequestOmeter'}</strong><br/>
          Species: ${p.species || '—'}<br/>
          Age: ${p.age || '—'} yr<br/>
          Flux: ${p.flux_tco2_ha_yr != null ? p.flux_tco2_ha_yr.toFixed(2) + ' tCO₂/ha/yr' : '—'}
        `);
      }}
    />
  );
}
